import {useSyncExternalStore} from 'react'
import {MockState} from './types'
import {seed} from './seed'

/* =========================================================================
   WMS · mock store — модуль-синглтон домена (см. D3 в плане: только домен,
   UI-состояние остаётся в компонентах). Персистится в localStorage, как
   в прототипе; версия ключа привязана к форме MockState — при её изменении
   меняем суффикс, чтобы старый закэшированный стейт не ронял приложение.
   ========================================================================= */

const STORAGE_KEY = 'wms-mock-v1'

function load(): MockState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) return JSON.parse(raw) as MockState
  } catch {
    /* повреждённый JSON / приватный режим — просто пересоздаём seed */
  }
  return seed()
}

function persist(next: MockState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    /* localStorage недоступен (приватный режим/квота) — работаем только в памяти */
  }
}

let state: MockState = load()
const listeners = new Set<() => void>()

/** Текущее состояние домена (для чтения вне React — action-функций). */
export function getState(): MockState {
  return state
}

/**
 * Уведомить подписчиков об изменении. Вызывается в конце каждого action'а
 * из actions.ts после мутации вложенных массивов/объектов состояния —
 * пересоздаёт верхнюю ссылку, чтобы useSyncExternalStore увидел изменение.
 */
export function notify(): void {
  state = {...state}
  persist(state)
  listeners.forEach((l) => l())
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

/** Хук: подписка на весь домен-стейт. Датасет небольшой — страницы сами выводят нужное через useMemo. */
export function useWmsMockStore(): MockState {
  return useSyncExternalStore(subscribe, getState)
}

/** Полный сброс к исходным демо-данным (кнопка «Сбросить данные»). */
export function resetMockStore(): void {
  state = seed()
  notify()
}
